import React, { useEffect, useState } from "react";
import images from "../../Constant/images";
import { Container } from "./styles";
import NewsComponent from "../../Components/NewsComponent";
import FaqsComponent from "../../Components/FaqsComponent";
import NewsDetails from "../../Components/NewsDetails";
import { VerticalAlign } from "../../Components/CustomStyles";
import ClipLoader from "react-spinners/ClipLoader";
import { useDispatch, useSelector } from "react-redux";
import Colors from "../../Constant/Colors";
import { getDownloadedNewsRequest } from "../../Redux/actions/home";
import { MainDiv } from "../NewsPage/styles";

const DownloadedNewsPage = ({ }) => {
  const dispatch = useDispatch();
  const { downloadedNews, newsLoading } = useSelector((state) => state.home);

  const [activeBlog, setActiveBlog] = useState(null);


  const handleBlog = (blog) => {
    setActiveBlog(blog);
  };
  const handleBack = () => {
    setActiveBlog(null);
  };
  useEffect(() => {
    if (!downloadedNews.length) dispatch(getDownloadedNewsRequest());
  }, []);

  return (
    <Container>
      <MainDiv>
        {newsLoading ? (
          <VerticalAlign style={{ height: 100 }}>
            <ClipLoader color={Colors.primary} size={20} />
          </VerticalAlign>
        ) : activeBlog ? (
          <NewsDetails
            handleBack={handleBack}
            blog={activeBlog}
            isNewsPage={false}
          />
        ) : (
          <NewsComponent
            heading={"My Downloads"}
            handleBlog={handleBlog}
            news={downloadedNews}
            isNewsPage={false}
          />
        )}
      </MainDiv>
      <FaqsComponent />
    </Container>
  );
};

export default DownloadedNewsPage;
